/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */

export type NonModeledAdjustmentActionDtoAction =
  (typeof NonModeledAdjustmentActionDtoAction)[keyof typeof NonModeledAdjustmentActionDtoAction];

export const NonModeledAdjustmentActionDtoAction = {
  RESET: 'RESET',
  SAVE: 'SAVE',
} as const;
